import type { User } from '../../types'
import { USERSSTATE } from '../state'
import { resolveID } from '../state/getState'
import { SUBSCRIBED_TO_WORKER_USER } from '../state/pubSub/workerSubscriptions'
import { loadUser } from './loadUser'

const excludedIdentifiers = ['fcserver']
const excluded = new Set<string | number>(excludedIdentifiers)

/**
 * Returns `USERSSTATE.users[id]` if subscribed to worker updates. If not,
 * calls `loadUser` to load the user from the worker state (performing
 * a lookup via API if necessary).
 */
export async function loadUserIfNeeded(
    identifier: string | number,
    ssrOverride = false,
): Promise<User> {
    if (!identifier || excluded.has(identifier)) return
    const id = resolveID(identifier)

    if (
        USERSSTATE.users[id] &&
        // if this is an initial page load, then lets assume it's for the SSR user,
        // which may not have a sub yet (as this can be called early in the
        // app startup process), but will be in the USERSSTATE already from server state
        (SUBSCRIBED_TO_WORKER_USER[id] || ssrOverride)
    ) {
        return USERSSTATE.users[id]
    }
    const exists = await loadUser(identifier)
    if (exists) {
        return USERSSTATE.users[resolveID(identifier)]
    }
    console.warn(
        '[loadUserIfNeeded] user does not exist!',
        identifier,
        resolveID(identifier),
    )
}
